export const LIVE_ROOM_RELEASE_DAYS_AFTER_PAYMENT = 7;

export function getLiveRoomReleaseDate(paidAt) {
  if (!paidAt) return null;

  const paymentDate = new Date(paidAt);
  if (Number.isNaN(paymentDate.getTime())) return null;

  const releaseDate = new Date(paymentDate);
  releaseDate.setDate(
    releaseDate.getDate() + LIVE_ROOM_RELEASE_DAYS_AFTER_PAYMENT
  );
  releaseDate.setHours(0, 0, 0, 0);

  return releaseDate;
}

export function isLiveRoomReleased({ isPaid, paidAt, now = new Date() }) {
  if (!(isPaid === 1 || isPaid === true || isPaid === "1")) return false;

  const releaseDate = getLiveRoomReleaseDate(paidAt);
  if (!releaseDate) return false;

  const today = new Date(now);
  if (Number.isNaN(today.getTime())) return false;
  today.setHours(0, 0, 0, 0);

  return today >= releaseDate;
}
